import { FC, HTMLAttributes, MouseEventHandler } from 'react';
import styles from './Breadcrumb.module.scss';
import Icon from '../icon/Icon';
import Link from 'next/link';
interface BreadcrumbProps extends HTMLAttributes<HTMLDivElement> {
  data: {
    title: string;
    href?: string;
    onClick?: MouseEventHandler<HTMLAnchorElement | HTMLSpanElement>;
  }[];
}
const Breadcrumb: FC<BreadcrumbProps> = ({
  data,
  className,
  ...rest
}) => {
  if (!data?.length) return <></>;
  return <nav className={`${className} ${styles['breadcrumb-container']}`} aria-label="breadcrumb" {...rest} data-sentry-component="Breadcrumb" data-sentry-source-file="Breadcrumb.tsx">
      {data.map((item, i) => <div className={styles['item']} key={item.title + i}>
          {item.href && i !== data.length - 1 ? <Link href={item.href} onClick={e => {
        item.onClick && item.onClick(e);
      }}>
              {item.title}
            </Link> : <span onClick={e => {
        item.onClick && item.onClick(e);
      }}>
              {item.title}
            </span>}
          {i !== data.length - 1 && <Icon name="arrow-left-1" type="highEmphasis" size={'small'} />}
        </div>)}
    </nav>;
};
export default Breadcrumb;